<template>
  <section id="vision" class="vision section-card" aria-labelledby="vision-heading" v-reveal>
    <div class="vision-content">
      <p class="label">Our Vision</p>
      <h2 id="vision-heading" class="title title-lg vision-title">
        A world where<br />shipping is simple
      </h2>
      <p class="subtitle subtitle-vision">
        We envision a future where everyone can ship seamlessly and confidently.
      </p>
    </div>
    <img
      :src="worldMapImage"
      alt="Dotted map of the world"
      class="vision-map"
      loading="lazy"
    />
  </section>
</template>

<script>
import worldMapImage from '../assets/landing2/world_map.svg';
import reveal from '../directives/scrollReveal';
import '../assets/styles/landing-shared.scss';

export default {
  name: 'Landing2Vision',
  directives: {
    reveal,
  },
  data() {
    return {
      worldMapImage,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/fluid';

.vision-title {
  margin-bottom: 1rem;
}

.subtitle-vision {
  font-size: 1.125rem;
  line-height: 1.6;
  color: var(--color-text-muted);
}

.vision {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  height: 25rem;
  padding: 0 3.75rem;
}

.vision-content {
  flex: 0 0 auto;
  max-width: 26rem;
}

.vision-map {
  flex: 0 1 auto;
  max-width: 36.75rem;
  height: 24rem;
  width: auto;
  object-fit: contain;
}

@media (max-width: 767px) {
  .vision {
    flex-direction: column;
    align-items: center;
    height: auto;
    padding: 0 1.375rem 4rem;
  }

  .vision-content {
    max-width: none;
    text-align: center;
  }

  .subtitle-vision {
    max-width: 17.5625rem;
    margin: 0 auto;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .vision-map {
    max-width: none;
    width: 100%;
    height: 14.125rem;
    margin-top: 2rem;
  }
}

@media (min-width: 768px) and (max-width: 1439px) {
  .vision {
    flex-direction: column;
    align-items: center;
    height: auto;
    padding: 0 fluid(1.375rem, 3.75rem) 4rem;
  }

  .vision-content {
    max-width: none;
    text-align: center;
  }

  .subtitle-vision {
    max-width: fluid(17.5625rem, 26rem);
    margin: 0 auto;
    font-size: fluid(0.875rem, 1.125rem);
    line-height: fluid(1.25rem, 1.8rem);
  }

  .vision-map {
    max-width: none;
    width: 100%;
    height: fluid(14.125rem, 24rem);
    margin-top: 2rem;
  }
}
</style>
